import IndexRoutes from "./routes/index-routes";
import useMediaQueries from "./hooks/useMediaQueries";
import MobilePage from "./pages/mobile_view/mobile_page";
import UnauthorizedModal from "./components/modals/unauthorized_modal";
import OfflineOverlay from "./components/overlay_message/overlay_message";
import { Toaster } from "sonner";
import { useAppStore } from "./store/appStore";
import { BrowserRouter, useLocation } from "react-router-dom";
import { APP_NAME, APP_VERSION } from "./constants/config";
import ChangeRoleModal from "./components/modals/change_role";
import ChangePasswordModal from "./components/modals/change_password";
import routes from "./constants/routes.json";

function App() {
  const appOffline = useAppStore((state) => state.appOffline);
  const { isMobile } = useMediaQueries();

  console.log(
    `%c${APP_NAME} - Version: ${APP_VERSION}`,
    "font-size: 20px; color:rgb(219, 219, 219); font-weight: bold; background-color:rgb(214, 17, 17); padding: 10px; border-radius: 5px;"
  );

  // Inner component must be rendered inside BrowserRouter so useLocation works
  const AppContent = () => {
    const location = useLocation();

    // Mobile-friendly paths can be provided via routes.MOBILE_FRIENDLY_PATHS (array).
    // Fallback to the single retail form path for backward compatibility.
    const mobileFriendlyPaths: string[] = routes.MOBILE_FRIENDLY_PATHS;

    // Check if current pathname matches any mobile-friendly path (prefix match).
    const isMobileAccessible = mobileFriendlyPaths.some((p) =>
      location.pathname.startsWith(p)
    );

    return (
      <>
        <OfflineOverlay
          show={appOffline}
          message="App is offline, please check your network"
        />
        <Toaster position="top-center" />
        {/* Render MobilePage for mobile devices EXCEPT when user is on any mobile-friendly route.
					 When on a mobile-friendly route we render IndexRoutes so the route is usable on mobile. */}
        {isMobile && !isMobileAccessible ? <MobilePage /> : <IndexRoutes />}
        <UnauthorizedModal />
        <ChangeRoleModal />
        <ChangePasswordModal />
      </>
    );
  };

  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
